import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Logout from '@/views/Logout'
import { getAuthToken } from '@/lib/auth'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/Dashboard'),
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '/cars',
      name: 'Cars',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/Cars'),
    },
    {
      path: '/cars/import',
      name: 'ImportPreloadCars',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/ImportPreloadCars'),
    },
    {
      path: '/cars/request-dispatch',
      name: 'RequestCustomsDispatch',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/RequestCustomsDispatch'),
    },
    {
      path: '/cars/request-pre-delivery',
      name: 'RequestPreDelivery',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/RequestPreDelivery'),
    },
    {
      path: '/cars/request-delivery',
      name: 'RequestDelivery',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/RequestDelivery'),
    },
    {
      path: '/cars/authorize-cars',
      name: 'AuthorizeCars',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/cars/AuthorizeCarsBatch'),
    },
    {
      path: '/cars/:id',
      name: 'CarView',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/cars/CarView'),
    },
    {
      path: '/cars/:id/charges',
      name: 'CarCharges',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "CarCharges" */ '@/views/cars/CarCharges'),
    },
    {
      path: '/transfers',
      name: 'Transfers',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/transfers/Transfers'),
    },
    {
      path: '/transfers/requested',
      name: 'RequestedTransfers',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/transfers/TransferRequests'),
    },
    {
      path: '/transfers/request-transfers',
      name: 'RequestTransfers',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "Cars" */ '@/views/transfers/RequestTransfers'),
    },
    {
      path: '/controls',
      name: 'Controls',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "CarView" */ '@/views/controls/Controls'),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const hasToken = !!getAuthToken()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  if (requiresAuth && !hasToken) {
    next('/login')
    return
  }

  if (hasToken && to.path === '/login') {
    next('/')
    return
  }

  next()
})

export default router
